import { useState } from "react";
import { FiVideo } from "react-icons/fi";
import VideoOrderModal from "./VideoOrderModal";

// Under the demo video in the job-posting popup (PostJobModal): an offer to have a
// video like it made for the employer's own company. The button opens VideoOrderModal,
// whose form goes to the internal dashboard; the wizard's phone and company name are
// handed through so the employer doesn't retype them.
export default function VideoOrderCard({ companyName = "", phone = "" }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-3xl bg-white shadow-2xl p-4 flex flex-col gap-3">
      {/* The offer, up top and loud */}
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#FFE83E] via-[#FFD93E] to-[#FFB23E] px-4 py-3">
        <div className="absolute -right-5 -top-6 w-20 h-20 rounded-full bg-white/30" aria-hidden="true" />
        <div className="absolute right-6 -bottom-8 w-14 h-14 rounded-full bg-white/20" aria-hidden="true" />
        <div className="relative flex items-center gap-3">
          <span className="text-[30px] font-black leading-none text-[#020618] tracking-tight">50%</span>
          <div className="leading-tight">
            <div className="flex items-center gap-1.5">
              <span className="inline-block rounded-full bg-[#020618] px-2 py-0.5 text-[10px] font-extrabold text-[#FFE83E] tracking-wider">
                OFF
              </span>
              {/* The regular price, struck through */}
              <s className="text-[12px] font-bold text-[#020618]/60 decoration-[#E11D48] decoration-2">1 сая ₮</s>
            </div>
            <p className="mt-1 text-[12px] font-bold text-[#020618]">12 сарын 15 хүртэл</p>
          </div>
        </div>
      </div>

      <p className="text-[12.5px] leading-snug text-[#475569]">
        Хэрэв та өөрийн компанид зориулж ийм бичлэг хийлгэхийг хүсвэл доорх товч дээр дарна уу.
      </p>

      <button
        type="button"
        onClick={() => setOpen(true)}
        className="h-11 rounded-[99px] bg-[#020618] text-[14px] font-bold text-white flex items-center justify-center gap-2
          hover:bg-[#29EAFF] hover:text-[#0F172B] transition-colors"
      >
        <FiVideo className="text-[16px]" />
        Бичлэг захиалах
      </button>

      <VideoOrderModal isOpen={open} onClose={() => setOpen(false)} companyName={companyName} phone={phone} />
    </div>
  );
}
